import React from 'react';
import {FormattedMessage, FormattedDate, FormattedTime} from 'react-intl';
import {
    FORM_CAR_REQUEST,
    FORM_CAR_REQUEST_SECTION, FORM_TICKET_SECTION
} from '../../../../../../constants/formConstants';
import {change, formValueSelector, getFormInitialValues} from 'redux-form';
import {connect} from 'react-redux';
import ValidFormattedMessage from '../../../../../common/ValidFormattedMessage';
import courtesyCarsMessages from '../../../../../../intl/sparePartsOrders/courtesyCarsMessages';
import formMessages from '../../../../../../intl/sparePartsOrders/formMessages';
import commonMessages from '../../../../../../intl/common/commonMessages';
import UploadedAttachments from '../attachments/UploadedAttachments';
import {moduleRoles} from '../../../../../../utils/roles';
import moment from 'moment';

const compare = (a, b) => {
    return moment(a.created).isAfter(b.created) ? 1 : -1;
};

const CarCourtesyTableRow = (props) => {
    const {carRequests, index, form, roles} = props;

    const canReadAttachment = (attachment) => {
        if (moduleRoles.isEditorOrder(roles) || moduleRoles.isSGEditorOrder(roles) || !attachment.solutionGroup) {
            return true;
        }
        return attachment.solutionGroup.canForwardToDealer;
    }

    const dealerAttachments = (index) => Object.keys(carRequests[index].attachments || [])
        .map(item => carRequests[index].attachments[item])
        .filter(item => item.isDealer)
        .sort(compare);

    const editorAttachments = (index) => Object.keys(carRequests[index].attachments || [])
        .map(item => carRequests[index].attachments[item])
        .filter(item => item.isEditor)
        .filter(item => canReadAttachment(item))
        .sort(compare);

    return (
        <div key={index} className="row m-0 align-items-stretch">
            <div style={{backgroundColor: '#f8f9fa'}} className="col-sm-12 col-lg-4 flex-column border-bottom">
                <div>
                    <FormattedDate value={new Date(carRequests[index].created)}/> <FormattedTime
                    value={new Date(carRequests[index].created)}/>
                    <span className="font-weight-bold">{' '}
                        <ValidFormattedMessage message={carRequests[index].isDealer ? 'DEALER' : 'EDITOR'}
                                               intlMessages={commonMessages}/>
                    </span>
                </div>
                <div>
                    {carRequests[index].userName + ' (' + carRequests[index].creatorIpn + ')'}
                </div>
            </div>
            <div className="col border-bottom">
                <div className="row m-0">
                    <div className="col font-weight-bold">
                        <FormattedMessage {...formMessages.CAR_REQUEST}/>:
                    </div>
                    <div className="col">
                        {carRequests[index].carRequest ?
                            <ValidFormattedMessage message={carRequests[index].carRequest} intlMessages={commonMessages}/> : '---'}
                    </div>
                </div>
                <div className="row m-0">
                    <div className="col font-weight-bold">
                        <FormattedMessage {...formMessages.HISTORY_REQUEST}/>:
                    </div>
                    <div className="col">
                        {carRequests[index].request ?
                            <ValidFormattedMessage message={carRequests[index].request} intlMessages={commonMessages}/> : '---'}
                    </div>
                </div>
                <div className="row m-0">
                    <div className="col font-weight-bold">
                        <FormattedMessage {...formMessages.HISTORY_CAR_TYPE}/>:
                    </div>
                    <div className="col " style={{minWidth: '150px'}}>
                        {carRequests[index].carType ?
                            <ValidFormattedMessage message={carRequests[index].carType}
                                                    intlMessages={courtesyCarsMessages}/> : '---'}
                    </div>
                </div>
                <div className="row m-0">
                    <div className="col font-weight-bold">
                        <FormattedMessage {...formMessages.HISTORY_INFORMATION}/>:
                    </div>
                    <div className="col">
                        {carRequests[index].information}
                    </div>
                </div>
                <div className="row m-0">
                    <div className="col font-weight-bold">
                        <FormattedMessage {...formMessages.LOAN_EXTENSION}/>:
                    </div>
                    <div className="col">
                        {carRequests[index].loanExtension ?
                            <ValidFormattedMessage message={carRequests[index].loanExtension} intlMessages={commonMessages}/> : '---'}
                    </div>
                </div>
                <div className="row m-0">
                    {(dealerAttachments(index) && dealerAttachments(index).length > 0) && <UploadedAttachments
                        attachments={dealerAttachments(index)} label={formMessages.JOINED_DOCUMENTS} form={form}/>
                    }
                    {(editorAttachments(index) && editorAttachments(index).length > 0) && <UploadedAttachments
                        attachments={editorAttachments} label={formMessages.JOINED_DOCUMENTS} form={form}/>
                    }
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = (state, initialProps) => ({
    carRequests: formValueSelector(initialProps.form)(state, `${FORM_CAR_REQUEST_SECTION}.${FORM_CAR_REQUEST}`),    
});

const mapDispatchToProps = (dispatch, props) => ({
    change: (name, value) => dispatch(change(props.form, name, value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(CarCourtesyTableRow);
